// The code below is used by jest unit test.
// When running unit test, it will replace webpack require.context method with babel plugin 'babel-plugin-require-context-hook'
process.env.NODE_ENV === 'test' && require('babel-plugin-require-context-hook/register')()

const messages = {}
const requirePaths = require.context('.', false, /\.js$/)

requirePaths.keys().forEach(fileName => {
  if (fileName === './index.js') {
    return
  }

  Object.assign(messages, requirePaths(fileName).default)
})

export default messages
